import GeckoAuth from '../gecko-auth';
import GeckoStore from '../gecko-store';
import GeckoRequest from '../gecko-request';

const AccountSwitcher = {
  BACKUP_KEY: 'account-switch-original',
  canSwitch: () => {
    return Boolean(GeckoStore.redux.get('appState.isSupport'));
  },
  isSwitchedIntoAccount: () => {
    return Boolean(GeckoAuth.hasBackup(AccountSwitcher.BACKUP_KEY));
  },
  switchTo: (accountId) => {
    if (!AccountSwitcher.canSwitch()) {
      return Promise.reject(
        new Error('Insufficient permissions to switch account')
      );
    }
    if (!accountId || !Number.isInteger(accountId)) {
      return Promise.reject(new Error('Invalid account picked to switch to'));
    }
    if (AccountSwitcher.isSwitchedIntoAccount()) {
      return Promise.reject(
        new Error('Switch back to your original account before switching')
      );
    }
    return GeckoRequest.get(`/admin/${accountId}`)
      .then((tokens) => {
        return GeckoAuth.backupTokens(AccountSwitcher.BACKUP_KEY).then(() => {
          return GeckoAuth.setTokens(tokens);
        });
      })
      .then(() => {
        window.location.reload();
      });
  },
  restoreOriginal: () => {
    return GeckoAuth.restoreBackup(AccountSwitcher.BACKUP_KEY).then(() => {
      window.location.reload();
    });
  },
};

export default AccountSwitcher;
